import type { ProductCustomerPrice } from '../../product/types';

const getCurrentPrice = ({
    customerPrices,
    selectedSku,
    isLoggedIn,
}: {
    customerPrices: ProductCustomerPrice[];
    selectedSku?: string;
    isLoggedIn: boolean;
}) => {
    if (selectedSku) {
        return {
            customerPrice: customerPrices.find(
                item => item.sku === selectedSku
            ),
            startingPrice: false,
        };
    } else {
        const priceProp: keyof ProductCustomerPrice = isLoggedIn
            ? 'finalPrice'
            : 'retailPrice';

        const smallestPrice = Math.min(
            ...customerPrices.map(variantPrice => {
                return variantPrice[priceProp]!;
            })
        );

        const smallestCustomerPrice = customerPrices.find(
            variantPrice => variantPrice[priceProp] === smallestPrice
        );

        return {
            customerPrice: smallestCustomerPrice,
            startingPrice: !customerPrices.every(
                variantPrice => variantPrice[priceProp] === smallestPrice
            ),
        };
    }
};

export default getCurrentPrice;
